// i18n area 'apps' — locale ro-RO (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.ro-RO.meta.json.
import type { enUS } from './apps'

export const roRO: typeof enUS = {
  apps: {
    title: 'Aplicații',
    create: 'Creează aplicație',
    createTitle: 'Creează aplicație',
    editTitle: 'Modifică aplicația',
    name: 'Nume',
    nameHint: 'DNS-1123, unic în scope — imutabil după creare.',
    node: 'Nod',
    nodeHint: 'Nodul membru care o servește — plasare explicită (schedulerul vine mai târziu).',
    image: 'Imagine',
    editImageHint: 'O referință nouă se rezolvă din nou prin evidența OCI — gestul de pin/rollback.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digestul se mișcă doar la comandă.',
    policyTrackingHint: 'Avansează automat când o reîmprospătare mută branch-ul.',
    archMovePolicy: 'Mutare cross-arch',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Ce se întâmplă dacă app-ul este mutat pe un nod de altă arhitectură: refuse refuză mutarea, reresolve re-rezolvă lockfile-ul din branch pe arch-ul nou — conținutul se schimbă, iar răspunsul numește schimbarea de digest.',
    network: 'Rețea',
    networkHint: 'Atașare L3 untagged: o rețea logică de fabric (recomandată — gateway/DNS din sursa ei unică), un overlay sau un bridge de host brut (nerecomandat).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'bridge de host:',
    ipAssignment: 'Atribuire IP',
    ipStatic: 'Static',
    ipAuto: 'Automat (IPAM)',
    ipAssignmentHint_static: 'Adresa o dai tu, acum.',
    ipAssignmentHint_auto: 'IPAM-ul alege o adresă liberă din intervalele rezervate TVirt ale rețelei.',
    bridgeDiscouraged: 'Bridge de host brut — NERECOMANDAT: TVirt nu știe nimic despre adresarea lui, așa că gateway-ul și DNS-ul trebuie date manual. Calea recomandată este o rețea logică de fabric.',
    ip: 'IP',
    ipHint: 'IPv4 static în subrețeaua atașării.',
    ipCidrHint: 'În formă CIDR pe un bridge brut (ex. 192.168.1.10/24) — nu are de unde să derive prefixul.',
    gateway: 'Gateway',
    gatewayManualHint: 'Manual — un bridge brut nu derivă nimic.',
    dnsServers: 'Servere DNS',
    dnsManualHint: 'Manual, separate prin virgulă — cel puțin unul.',
    rootKind: 'Root',
    rootEphemeral: 'efemeră',
    rootPersistent: 'persistentă',
    rootEphemeralHint: 'Recreată din imagine la fiecare recreare; trăiește pe storage-ul efemer al clusterului.',
    rootEphemeralHintNamed: 'Recreată din imagine la fiecare recreare; trăiește pe storage-ul efemer al clusterului ({name}).',
    rootPersistentHint: 'Supraviețuiește repornirilor; trăiește pe storage-ul pe care îl alegi.',
    rootStorage: 'Storage pentru root',
    editRootStorageHint: 'Root-ul se rematerializează pe noul pool — datele existente NU se mută singure.',
    volumes: 'Volume',
    volumeAdd: 'Adaugă volum',
    volumeName: 'Nume',
    volumeMountPath: 'Cale de montare',
    volumeKind: 'Tip',
    volumeStorage: 'Storage',
    devices: 'Dispozitive',
    deviceClassHint: 'Se cere o CLASĂ (o etichetă gpu-device sau usb-device), niciodată un dispozitiv anume: nodul declarat trebuie să aibă unul marcat pentru Apps. Mai multe Apps pot folosi același dispozitiv — un container îl partajează, nu i-l ia gazdei.',
    deviceSlot: 'Slot',
    deviceTag: 'Etichetă',
    deviceValue: 'Clasă',
    deviceUnresolved: 'acum nu se rezolvă nimic',
    noDeviceTags: 'Încă nicio etichetă de tip gpu-device sau usb-device: creează una și atribuie-o dispozitivelor marcate pentru Apps.',
    env: 'Mediu',
    envHint: 'Câte o CHEIE=valoare pe linie.',
    secretEnvTitle: 'Variabile secrete',
    secretEnvNotice: 'O valoare secretă nu se mai întoarce niciodată din API: nimeni nu o mai citește, nici măcar cine a scris-o. În checkpoint călătorește sigilată cu masterpass-ul, așa că o restaurare fără masterpass va cere rescrierea ei.',
    secretEnvPromote: 'Fă secretă una dintre variabilele scrise mai sus:',
    secretEnvAdd: 'Adaugă variabilă secretă',
    secretEnvName: 'Nume',
    secretEnvValue: 'Valoare',
    secretEnvKept: 'păstrată — lasă gol ca să nu o schimbi',
    secretEnvWithdrawWarning: 'Ca să nu mai tratezi ca secretă o variabilă care deja este, scrie-i o valoare nouă: retragerea singură a marcajului ar fi un mod de a CITI ceea ce nu iese niciodată din store. În schimb, eliminarea ei o șterge.',
    secretEnvChip: 'secret',
    startNow: 'Pornește imediat (altfel aplicația se creează oprită)',
    deletePersistentIntro: 'Această aplicație are date persistente — alege ce se întâmplă cu ele:',
    deleteKeepData: 'Păstrează datele (directoarele rămân pe storage-urile lor, orfane)',
    deletePurgeData: 'Șterge și datele',
    phase: 'Fază',
    phase_running: 'În execuție',
    phase_stopped: 'Oprită',
    phase_error: 'Eroare',
    phase_unknown: 'Necunoscută',
    desiredState: 'Dorit',
    wantedRunning: 'în execuție',
    wantedStopped: 'oprită',
    start: 'Pornește',
    stop: 'Oprește',
    restart: 'Repornește',
    refreshImage: 'Actualizează imaginea (adoptă noul @current)',
    logs: 'Loguri',
    logsTitle: 'Loguri',
    logsEmpty: 'Niciun output capturat.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App-ul nu rulează — un shell are nevoie de un container viu. Logurile lui se citesc în orice stare.',
    shellConnect: 'Conectare',
    shellDisconnect: 'Deconectare',
    shellExited: 'Sesiunea s-a încheiat cu codul de ieșire {code}.',
    shellEndedWithoutStatus: 'Sesiunea s-a încheiat fără o stare de ieșire: {reason}',
    shellRevoked: 'Ticketul sesiunii nu mai este valid — a expirat, sau autentificarea care l-a deschis a fost revocată.',
    shellHint: 'Dă clic în chenarul negru și scrie: tastele ajung la container. Ctrl+C și săgețile funcționează; exit închide shell-ul.',
    shellStatus: {
      connecting: 'Se conectează…',
      connected: 'Conectată',
      ended: 'Încheiată'
    },
    deleteRunningError: '{name} este dorită în execuție — oprește-o mai întâi.',

    tabs: {
      general: 'General',
      image: 'Imagine',
      network: 'Rețea',
      storage: 'Storage',
      devices: 'Dispozitive',
      observed: 'Observat'
    },
    attachment: 'Atașare',
    runningDigest: 'Digestul în execuție',
    lastError: 'Ultima eroare',
    reportObservedAt: 'Ultimul raport al workerului',
    desiredStateLock: 'Îl guvernează acțiunile Pornește/Oprește — niciodată o modificare directă.',
    ipEditDisabledHint: 'Modificabil doar cu atribuire statică.',
    derivedFromNetworkHint: 'Derivat din sursa unică a rețelei — manual doar pe un bridge brut cu IP static.',
    ephemeralUnset: 'neconfigurat',
    ephemeralMissing: 'Storage-ul efemer al Aplicațiilor nu este configurat — crearea unei aplicații cu piese efemere (root sau volume) este refuzată până când îl setezi.',
    ephemeralCurrent: 'Storage-ul efemer al Aplicațiilor: {name}',
    ephemeralMissingCreate: 'Această aplicație are piese efemere, dar storage-ul efemer al Aplicațiilor nu este setat — crearea va fi refuzată. Setează-l mai întâi din bannerul paginii Aplicații.',
    setEphemeral: 'Setează storage-ul efemer',
    changeEphemeral: 'Schimbă storage-ul efemer',
    setEphemeralTitle: 'Setează storage-ul efemer al Aplicațiilor',
    changeEphemeralTitle: 'Schimbă storage-ul efemer al Aplicațiilor',
    ephemeralStorageHint: 'IMPLICIT la nivel de cluster: pool-ul dir-like unde trăiesc root-urile și volumele efemere ale fiecărei aplicații, dacă aplicația nu declară propriul override. O schimbare nu este la cald și nu repornește nimic: se aplică de la următoarea pornire a fiecărei aplicații — datele efemere nu se mută.',
    ephemeralPool: 'Pool de storage',
    ephemeralOverride: 'Storage efemer (override per aplicație)',
    ephemeralOverrideInherit: 'Moștenește valoarea implicită a clusterului',
    ephemeralOverrideInheritNamed: 'Moștenește valoarea implicită a clusterului ({name})',
    ephemeralOverrideHint: 'Pool per aplicație pentru root-ul și volumele efemere — lasă gol ca să moștenești valoarea implicită a clusterului. Schimbarea nu este la cald și nu repornește nimic: se aplică de la următoarea pornire (datele efemere renasc goale pe noul pool) și cere permisiunea app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Toate branch-urile',
    imageBranchHint: 'Restrânge imaginile la cele numite de acest branch; fără branch se văd toate imaginile repository-ului.',
    imageDigestHint: 'Conținutul: se alege din tabelul digesturilor, care îi poartă proveniența și arhitectura. Același branch oferă câte unul pe arhitectură, iar ele nu sunt interschimbabile.',
    imageLockfile: 'Referință rezolvată',
    imageNoImages: 'Nicio imagine în cache pentru acest repository — descarcă una din Imagini OCI.',
    imageHeadNotCached: 'nu este în cache — descărcat la pornire',
    imageNoRegistries: 'Niciun repository înregistrat: înregistrează unul ca să poți alege o imagine.',
    imageChosenHint: 'Imaginea se alege din cascada dialogului de modificare: referința nu se scrie niciodată de mână.',
    registerRepositoryHint: 'Înregistrarea nu descarcă nimic: face un repository observabil, ca imaginea să poată fi aleasă fără a părăsi acest dialog.',
    registerRepositoryBranchHint: 'Opțional: primul branch de observat (de ex. latest).',
    registerRepositoryElsewhere: 'Repository-ul căutat nu este înregistrat: înregistrarea se face în secțiunea Imagini OCI, de cine are permisiunea.'
  },

  cts: {
    createAction: 'Creează CT',
    createTitle: 'Creează un container dintr-un template',
    createError: 'Containerul nu a putut fi creat',
    template: 'Template CT',
    noTemplates: 'Niciun template CT — importă unul din Template-uri CT',
    resources: 'Resurse',
    node: 'Nod',
    phase: {
      defined: 'Niciodată pornit',
      materializing: 'În materializare',
      ready: 'Gata',
      starting: 'În pornire',
      running: 'În execuție',
      stopping: 'În oprire',
      stopped: 'Oprit',
      deleting: 'În ștergere',
      error: 'În eroare'
    },
    actions: {
      start: 'Pornește',
      stop: 'Oprește',
      restart: 'Repornește',
      markTemplate: 'Promovează la template CT',
      error: 'Acțiunea a fost refuzată'
    },
    markTemplate: {
      confirmTitle: "Promovezi '{name}' la template CT?",
      confirmBody: 'Containerul părăsește această listă și trece la Template-uri CT, gata imediat să genereze CT-uri noi. Metadatele rămân modificabile și îl poți readuce la CT oricând.',
      confirm: 'Promovează',
      moved: "'{name}' este acum un template CT — îl găsești în Template-uri CT."
    },
    stopCause: {
      api: 'Oprit prin TVirt',
      'ct-exit': 'Containerul s-a oprit de la sine',
      'host-reboot': 'A murit la repornirea nodului',
      'start-failed': 'Pornirea a eșuat — eroarea taskului spune ce lipsește și cum se rezolvă'
    },

    console: 'Consolă',
    consoleUnavailable: 'Containerul nu este în execuție — o consolă are nevoie de un container viu. Logurile lui, în schimb, se citesc în orice stare.',
    consoleNoTemplate: 'Un template nu rulează niciodată, deci nu are consolă: creează un CT din el și deschide-o pe a aceluia.',
    consoleConnect: 'Conectează',
    consoleDisconnect: 'Deconectează',
    consoleReconnect: 'Reconectează',
    consoleTakenBy: 'Alt operator a preluat această consolă ({user}). O consolă per container: reconectarea ți-o ia înapoi.',
    consoleHint: 'Dă clic pe zona neagră și scrie: tastele ajung la container. Ctrl+C și săgețile funcționează.',
    consoleEndpointDown: 'Punctul de acces al consolei nu se deschide pe nodul care servește containerul: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Containerul nu rulează — un shell are nevoie de un container viu. Logurile lui se citesc în orice stare.',
    shellNoTemplate: 'Un template nu rulează niciodată, deci nu are shell: creează un CT din el și deschide-l pe al acestuia.',
    shellConnect: 'Conectare',
    shellDisconnect: 'Deconectare',
    shellExited: 'Sesiunea s-a încheiat cu codul de ieșire {code}.',
    shellEndedWithoutStatus: 'Sesiunea s-a încheiat fără o stare de ieșire: {reason}',
    shellRevoked: 'Ticketul sesiunii nu mai este valid — a expirat, sau autentificarea care l-a deschis a fost revocată.',
    shellHint: 'Dă clic în chenarul negru și scrie: tastele ajung la container. Ctrl+C și săgețile funcționează; exit închide shell-ul.',
    shellStatus: {
      connecting: 'Se conectează…',
      connected: 'Conectată',
      ended: 'Încheiată'
    },
    rootPassword: 'Parola root',
    rootPasswordHint: 'Scrisă o singură dată în rootfs-ul copiat (ca hash, nu mai este afișată). Imaginile distribuțiilor nu au parolă root: fără ea, shell-ul este singura intrare.',
    sshKeys: 'Chei SSH publice ale lui root',
    sshKeysHint: 'O cheie publică OpenSSH pe linie, în root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Conectare…',
      connected: 'Conectată',
      reconnecting: 'Reconectare…'
    },
    logs: 'Loguri',
    logsTitle: 'Loguri',
    logsEmpty: 'Niciun output capturat.',
    logsSource: 'Care log',
    logsSourceConsole: 'Consola init a containerului — de ce serviciul dinăuntru nu a pornit',
    logsSourceSupervisor: 'Supervizorul liblxc — de ce containerul nu a ajuns niciodată să ruleze',
    logsNeverStarted: 'Nu a fost pornit niciodată, deci încă nu e nimic înregistrat — pornește-l, iar logurile vor fi acolo chiar dacă pornirea eșuează.',
    logsNoTemplate: 'Un template nu rulează niciodată, deci nu a înregistrat nimic vreodată.',
    logsError: 'Logurile nu au fost capturate',

    tabs: {
      general: 'General',
      hardware: 'Hardware',
      network: 'Rețea',
      provenance: 'Proveniență'
    },
    templateFlag: 'Template CT',
    templateLock: 'Se schimbă doar prin acțiunile Promovează / Readu la CT — niciodată o modificare directă.',
    sourceLock: 'Proveniență, înregistrată la naștere — niciodată rescrisă; o sursă moartă lasă referința goală.',
    storageLock: 'Fixat la creare — mutarea rootfs-ului este o rundă viitoare.',
    startedAt: 'Pornit',
    lastStop: 'Ultima oprire',
    editNicsTitle: 'Modifică rețelele',
    nicDisconnected: 'deconectată'
  },
  ctTemplates: {
    title: 'Template-uri CT',
    importAction: 'Importă din catalog',
    importTitle: 'Importă un template CT din catalog',
    importSubmit: 'Importă',
    importError: 'Importul a fost refuzat',
    importHint: 'Materializarea copiază rootfs-ul pe storage-ul ales — fișierul din catalog rămâne neatins. Ca să adaugi fișiere noi, încarcă-le mai întâi într-un catalog.',
    sourceFile: 'Fișier template CT',
    sourceFileHint: 'Fișierele ct-rootfs ale catalogului ales, doar cele gata',
    noFiles: 'Niciun fișier ct-rootfs gata în acest catalog — încarcă unul din pagina catalogului',
    source: 'Fișier sursă',
    rootfsStorage: 'Storage pentru rootfs',
    rootfsStorageHint: "Unde trăiește arborele rootfs extras — un storage cu sistem de fișiere și suficient spațiu liber pentru dimensiunea extrasă plus o marjă de circa 1 GiB (altfel importul eșuează).",
    resources: 'Resurse',
    cores: 'vCPU',
    memoryMiB: 'Memorie (MiB)',
    cpuLimit: 'Limită CPU',
    cpuLimitHint: 'Echivalente de core-uri de host (ex. 1.5); gol = fără plafon',
    cpuUncapped: 'fără plafon',
    cpuWeight: 'Pondere CPU',
    hostname: 'Hostname',
    hostnameHint: 'Gol = numele CT-ului',
    nameservers: 'Nameservere DNS',
    dnsHint: 'Separate prin virgulă; gol = moștenește serverele hostului',
    searchDomains: 'Domenii de căutare DNS',
    dnsInherited: 'Moștenit de la host',
    networks: 'Rețele',
    nicSlot: 'Slot NIC',
    phase: {
      materializing: 'În materializare',
      ready: 'Gata',
      deleting: 'În ștergere',
      error: 'Eroare'
    },
    exportAction: 'Exportă în catalog',
    exportTitle: 'Exportă în catalog',
    exportSubmit: 'Exportă',
    exportError: 'Exportul a fost refuzat',
    exportHint: 'Împachetează rootfs-ul materializat într-un fișier ct-rootfs NOU în catalogul ales — template-ul rămâne neatins.',
    exportName: 'Numele fișierului',
    exportNameHint: 'Gol = <template>-export-<n>',
    markCt: {
      action: 'Readu la CT',
      confirmTitle: "Readuci '{name}' la CT?",
      confirmBody: 'Template-ul părăsește această listă și revine în lista CT, din nou pornibil. Până când îl promovezi din nou, nu se pot crea CT-uri din el.',
      confirm: 'Readu la CT',
      moved: "'{name}' este din nou un CT — îl găsești în lista CT."
    }
  },

  oci: {
    registriesTitle: 'Registry-uri OCI',
    imagesTitle: 'Imagini OCI',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Generic',
    providerImmutableHint: 'Providerul este imutabil după creare — un provider diferit înseamnă un registry nou.',
    url: 'URL',
    urlHintPreset: 'Precompletat de provider — suprascrie doar pentru mirror-uri.',
    urlHintRequired: 'Obligatoriu pentru registry-urile generice: URL-ul de bază https://.',
    urlHintEcr: 'Obligatoriu: endpointurile ECR sunt per cont/per regiune — nu există preset.',
    credential: 'Credențiale',
    credentialNone: 'Acces anonim',
    credentialHint: 'O intrare de keystore cu utilizator și parolă; workerii o rezolvă la momentul folosirii — niciodată fișiere de autentificare per nod.',
    nameHint: 'Nume de tip host (docker.io, registry.intra); unic per scope, imutabil',
    addRegistry: 'Adaugă registry',
    addRegistryTitle: 'Adaugă registry OCI',
    verify: 'Verifică',
    verifyState: 'Verificare',
    verified: 'Verificat',
    verifyFailed: 'Eșuată',
    neverVerified: 'Niciodată verificat',
    registryInUseError: "'{name}' are încă repository-uri înregistrate — șterge-le mai întâi.",
    repositories: 'Repository-uri',
    repositoriesHint: 'Înregistrarea observă branch-urile (taguri OCI) — nu descarcă nimic. Reîmprospătarea rezolvă fiecare branch observat și păstrează reflogul.',
    noRepositories: 'Niciun repository înregistrat pe acest registry.',
    registerRepository: 'Înregistrează repository',
    repoPath: 'Cale',
    repoPathHint: "Calea repository-ului pe registry, ex. 'example' sau 'library/nginx'",
    branches: 'Branch-uri',
    branchesHint: 'Branch-uri observate (taguri OCI), separate prin virgulă — ex. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Rezolvat ACUM: pull-ul descarcă digestul spre care arată branch-ul astăzi.',
    refresh: 'Reîmprospătează',
    deleteRepository: 'Șterge repository-ul',
    reflogCount: 'anterioare: {n}',
    noResolutions: 'Niciodată reîmprospătat — nicio rezolvare observată încă.',
    refreshFailed: 'Ultima reîmprospătare a eșuat ({when})',
    loadError: 'Nu s-au putut încărca repository-urile.',
    reference: 'Referință',
    digest: 'Digest',
    digestHint: 'sha256:… — imaginea exactă, fără branch (detached)',
    size: 'Dimensiune',
    nodes: 'Noduri',
    detached: 'detached',
    detachedHint: 'Descărcată după digest, fără branch — verificarea de drift nu se aplică.',
    pulledAt: 'Descărcată',
    pull: 'Pull',
    pullTitle: 'Pull de imagine',
    pullHint: 'Pre-warming, niciodată o precondiție: un pull după branch rezolvă ACUM și descarcă ACEL digest; un pull după digest este detached.',
    pullError: 'Pull-ul a fost refuzat',
    pullMode: 'Pull după',
    pullModeBranch: 'Branch (rezolvă acum)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Alegerea implicită onestă: ca apt install, rulat din nou mai târziu poate da o altă imagine.',
    pullModeDigestHint: 'Digest exact — reproductibilitate și rollback; renunță la verificarea de drift.',

    importFromRegistry: 'Importă din registry',
    importFromCatalog: 'Importă din catalog',
    importCatalogTitle: 'Importă o imagine OCI din catalog',
    importCatalogHint: 'Calea air-gapped: o arhivă oci-image gata (tar/tar.gz — docker-archive sau oci-archive) este materializată în store-ul de imagini cu referința catalog/<catalog>/<file>@<digest>; aplicațiile o consumă ca pe orice altă imagine. Arhivele se încarcă în cataloage — această secțiune doar importă.',
    importCatalogFile: 'Arhivă',
    importCatalogFileHint: 'Fișierele oci-image gata ale catalogului ales.',
    importCatalogNoFiles: 'Nicio arhivă oci-image gata în acest catalog — încarcă una din detaliul catalogului.',
    importCatalogError: 'Importul a fost refuzat',
    registry: 'Registry',
    repository: 'Repository',
    cacheMissing: 'Cache-ul OCI al clusterului nu este configurat — pull-urile sunt refuzate până când setezi un pool de storage.',
    setCache: 'Setează cache-ul',
    setCacheTitle: 'Configurează cache-ul OCI',
    setCacheHint: 'Pool-ul IMPLICIT la nivel de cluster care găzduiește bloburile imaginilor descărcate — un scope poate face override cu propriul pool (pagina Scope-uri). Schimbarea nu este la cald și nu repornește nimic, și nu mută bloburile: reapar lazy la următoarea pornire/utilizare.',
    cachePool: 'Pool de storage',
    changeCache: 'Schimbă cache-ul',
    changeCacheTitle: 'Schimbă pool-ul cache-ului OCI',
    cacheCurrent: 'Cache-ul OCI al clusterului (implicit): {name}',
    sectionOverview: 'Prezentare generală',
    sectionRepositories: 'Repository-uri',
    sectionExplore: 'Explorează',
    exploreHint: 'Căutare remote în timp real pe registry — Docker Hub complet (descriere, descărcări, stele), ceilalți provideri best-effort. Selectează un rezultat ca să îi citești descrierea completă și să îi răsfoiești tagurile remote; dintr-un tag poți adăuga referința într-un repository TVirt.',
    exploreSearch: 'Caută',
    exploreUnsupported: 'Acest provider nu suportă căutarea.',
    exploreNoResult: 'Niciun repository nu corespunde.',
    exploreNoTags: 'Niciun tag nu corespunde în acest repository.',
    exploreOfficial: 'Oficial',
    explorePulls: 'Descărcări',
    exploreStars: 'Stele',
    exploreUpdated: 'Actualizat {when}',
    exploreLoadMore: 'Încarcă mai multe',
    exploreSelectHint: 'Selectează un rezultat: descrierea completă și tagurile remote se încarcă aici.',
    exploreNoDescription: 'Nicio descriere disponibilă de la acest provider.',
    exploreTagsTitle: 'Taguri remote',
    exploreTagFilter: 'Caută taguri',
    exploreAddToRepo: 'Adaugă în repository',
    exploreAdded: '{path}:{tag} este acum urmărit — vezi secțiunea Repository-uri.',
    addBranch: 'Adaugă branch',
    purgeRequiredTitle: "Ștergi '{name}' și imaginile sale?",
    purgeRequiredBody: 'Nicio aplicație nu consumă acest repository, dar există încă imagini descărcate: ștergerea lui elimină și înregistrările lor, iar bloburile din cache trec la garbage collector.',
    purgeConfirm: 'Șterge și imaginile',
    providerSelectHint: 'Selectează tipul de registry: cardul spune presetul și utilizarea.',
    providerDesc: {
      dockerhub: 'Registry-ul public Docker: URL precompletat, căutare completă cu descrieri și contoare.',
      ghcr: 'GitHub Container Registry: URL precompletat; conturile folosesc un personal access token.',
      ecr: 'Amazon Elastic Container Registry: endpointuri per cont/per regiune — URL-ul trebuie indicat.',
      quay: 'Registry-ul Red Hat Quay: URL precompletat.',
      generic: 'Registry self-hosted (Harbor, registry:2, …): URL-ul https:// este obligatoriu.'
    },

    layerCount: 'Layere',
    verifiedAt: 'Ultima verificare',
    verifyOk: 'Rezultat',
    verifyMessage: 'Mesajul verificării',

    // Modelul #348/R39: imaginea ESTE digestul — conținutul — iar registry, repository și branch sunt NUMELE care ajung la el.
    head: 'Head',
    heads: 'Capete pe arhitectură',
    listDigest: 'Digestul listei',
    neverResolved: 'Niciodată rezolvat',
    totalSize: 'Dimensiune totală',
    reflogTitle: 'Istoricul rezolvărilor',
    usedBy: 'Folosit de',
    usageLockfile: 'lockfile',
    usageRunning: 'în execuție',
    evictable: 'evacuabil',
    evict: 'Evacuare din cache',
    evictHeadTitle: 'Evacuezi {digest}?',
    evictHeadBody: 'Este rezolvarea curentă a cel puțin unui colector: evacuarea lui este legitimă — este doar cache, branch-ul remote încă îl servește — dar nu trebuie să se întâmple din greșeală. Blobul este UNUL singur: evacuarea golește toate colectoarele care îl partajează.',
    evictConfirm: 'Evacuează-l oricum',

    arch: 'Arhitectură',
    names: 'Nume',
    noNames: 'fără nume',
    views: 'Vizualizări',
    lastView: 'ultima vizualizare',
    evictLastViewTitle: 'Elimini ultima referință la {digest}?',
    evictLastViewBody: 'Este ultima vizualizare a acestui conținut: eliminând-o, imaginea încetează să existe pe TVirt și octeții ({size}) sunt eliberați. Este docker image rm al modelului — nu un efect secundar, ci operațiunea însăși.',
    branchesTabHint: 'Branch-urile observate ale acestui repository: pentru fiecare capetele de azi — câte unul pe arhitectură — cronologia reîmprospătărilor și câte dintre imaginile numite de el sunt în cache. Reîmprospătarea este «git fetch»-ul repository-ului: rezolvă toate branch-urile dintr-o dată.',
    noBranches: 'Niciun branch observat pe acest repository.',
    stopObserving: 'Nu mai observa branch-ul',
    pullBranch: 'Descarcă în cache capul branch-ului (refresh-ul rezolvă, acesta descarcă)',
    pullDigest: 'Descarcă în cache acest digest',
    imageCount: 'Imagini',
    deleteBranchPurgeTitle: 'Lași imaginile din {name} fără nume?',
    deleteBranchPurgeBody: 'Nicio aplicație nu numește acest branch, dar unele imagini sunt atinse doar prin el: ștergându-l, rămân în cache fără nume, listate printre imaginile repository-ului și eliminabile manual.',
    deleteBranchPurgeConfirm: 'Șterge și lasă imaginile fără nume',
    imagesTabHint: 'Imaginile acestui repository — conținuturile, adică digesturile — vizibile și fără a alege un branch. O imagine este unică pe cluster: numele care ajung la ea pot fi mai multe.',
    noImages: 'Nicio imagine a acestui repository nu este materializată în cache.',
    deleteRepositoryTitle: 'Ștergi {name}?',
    deleteRepositoryBody: 'Repository-ul și branch-urile lui dispar, cu tot cu cronologie. Imaginile rămân în cache: pierd doar acest nume. Un repository numit de o aplicație nu se poate șterge.',
    provenanceCatalog: 'catalog',
    refreshedAt: 'Reîmprospătat',
    neverRefreshed: 'Niciodată reîmprospătat',
    sectionBranches: 'Branch-uri',
    sectionImages: 'Imagini',
    repositoriesGovernedElsewhere: 'Aici repository-urile doar se privesc: înregistrarea, reîmprospătarea, observarea branch-urilor și eliminarea imaginilor se fac în secțiunea Imagini OCI.',
    gotoImages: 'Mergi la Imagini OCI'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Poduri',
    containers: 'Containere',
    instances: 'Instanțe',
    instancesTooltip: '{running} în execuție, {error} cu eroare',
    placement: 'Amplasare',
    spread: 'distribuire',
    ha: 'HA',
    templateRevision: 'revizie',
    deleting: 'Se șterge',
    empty: 'Niciun pod — creați o aplicație (un container) sau un pod din CLI (create-pod).',
    openInstances: 'Deschide instanțele',
    rollingRestart: 'Repornire progresivă',
    scale: 'Scalare',
    scaleTitle: 'Scalare {name}',
    scaleHint: 'Numărul de instanțe (0–64): în sus se ocupă cel mai mic ordinal liber, în jos se retrage cel mai mare, iar datele sale persistente rămân.',
    scaleError: 'Scalarea a eșuat',
    replicas: 'Replici',
    deleteRunningError: '{name} este în execuție — opriți-l mai întâi.',
    deleteInstancesIntro: 'Toate cele {count} instanțe vor fi eliminate.',
    stateRunning: 'În execuție',
    stateStopped: 'Oprit',
    editor: {
      createTitle: 'Creează Pod',
      create: 'Creează Pod',
      editTitle: 'Editează Pod',
      nameHint: 'DNS-1123, cel mult 58 de caractere — instanțele se numesc <nume>-<index>; imuabil după creare.',
      restartPolicy: 'Politica de repornire',
      restartPolicyHint_always: 'Nodul repornește orice container ieșit, cu backoff exponențial (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Se repornește doar un container ieșit cu cod diferit de zero; ieșirea 0 rămâne în repaus.',
      restartPolicyHint_never: 'Un container ieșit rămâne așa cum este — instanța se încheie succeeded sau failed.',
      grace: 'Grație (s)',
      graceHint: 'Limita SIGTERM → SIGKILL a unei opriri.',
      hostname: 'Nume de gazdă',
      hostnameHint: 'Gol = numele instanței.',
      hostnameDefault: 'numele instanței',
      sharePid: 'Partajează spațiul de nume PID între containere',
      containersIntro: 'Containerele init rulează până la capăt, în ordine, înainte ca containerele să pornească; containerele partajează rețeaua instanței (un IP, localhost între ele).',
      initContainers: 'Containere init',
      initAdd: 'Adaugă container init',
      initHint: 'Fiecare trebuie să iasă cu 0; un eșec pune instanța în eroare și nodul îl reîncearcă cu backoff.',
      containerAdd: 'Adaugă container',
      atLeastOne: 'Un Pod are nevoie de cel puțin un container.',
      duplicateNames: 'Numele containerelor trebuie să fie unice în Pod (inclusiv containerele init).',
      containerName: 'Numele containerului',
      containerInvalid: 'Acest container este incomplet: nume (DNS-1123), imagine, montări pe volume declarate, limite și sondă numerice.',
      command: 'Comandă',
      commandHint: 'Înlocuiește entrypoint-ul imaginii — un argument pe linie, niciodată un șir shell.',
      args: 'Argumente',
      argsHint: 'Unul pe linie (CMD-ul imaginii dacă e gol).',
      mounts: 'Montări',
      mountAdd: 'Adaugă montare',
      mountNoVolumes: 'Declarați mai întâi un volum în fila Stocare.',
      readOnly: 'doar citire',
      resources: 'Limite',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (ex. 1.5)',
      memory: 'Memorie (MiB)',
      memoryHint: 'podman --memory',
      health: 'Sondă de viabilitate',
      healthCmd: 'Comanda sondei',
      healthCmdHint: 'Rulată în container de către nod la fiecare tact de supraveghere — un argument pe linie; ieșire 0 = sănătos.',
      healthTimeout: 'Timp limită (s)',
      healthRetries: 'Reîncercări',
      healthRetriesHint: 'Eșecuri consecutive înainte ca nodul să repornească containerul.',
      ips: 'Adrese statice',
      ipsHint: 'Una per instanță, în ordinea ordinalelor — o scalare dincolo de listă este refuzată.',
      instance: 'instanță',
      volumesHint: 'Volumele sunt ale Pod-ului; calea de montare este a fiecărui container (fila Containere).',
      spread: 'Distribuție',
      spreadHint_preferred: 'Instanțe pe noduri diferite când este posibil.',
      spreadHint_required: 'Instanțe pe noduri diferite, altfel scalarea refuză.',
      spreadHint_none: 'Doar decidentul.',
      ha: 'Disponibilitate ridicată (opt-in)',
      haHint: 'Fiecare piesă persistentă pe storage partajat; dacă nodul moare, decider-ul HA recreează instanțele pe alt membru (failover automat, ca la VM-urile HA).',
      yes: 'da',
      no: 'nu'
    },
    detail: {
      container: 'Container',
      actions: 'Acțiuni',
      ready: 'Gata',
      notReady: 'Nu e gata',
      restarts: 'Reporniri',
      lastRestartAt: 'Ultima repornire:',
      backoffUntil: 'Reîncercare la',
      stateAbsent: 'absent',
      stateRunning: 'rulează',
      stateTerminated: 'terminat',
      stateWaiting: 'în așteptare',
      init: 'init',
      noInstances: 'Nicio instanță (replici 0).',
      ha: 'HA',
      haHint: 'Failover automat: dacă nodul moare, decider-ul HA recreează instanța pe alt membru (fiecare piesă persistentă pe storage partajat).',
      authority: 'Authority (nod)',
      homeless: 'fără authority',
      homelessHint: 'O restaurare din checkpoint lasă authority deoparte (#380): niciun nod nu o servește până nu scalați Pod-ul (chiar și la același număr de replici).',
      restartContainer: 'Repornește doar acest container (pod-ul rămâne activ)',
      divergingHint: 'Starea dorită a acestei instanțe diferă de implicitul Pod-ului (PD-P19).',
      revisionLag: 'revizia {applied} aplicată din {current}',
      updatedInstances: '{updated}/{desired} instanțe la această revizie'
    }
  }
}
